import React from 'react'
import { Avatar, Grid, MenuItem, TextField, withStyles } from '@material-ui/core'
import UserAvatarName from '../Structure/DisplayData/UserAvatarName'
import { ruleValidation } from './customFunctions'
import { isValidDocument } from '../../shared/utility';
import { CONFIG_SETTINGS } from '../../config'

const CssTextField = withStyles({
    root: {
      '& label.Mui-focused': {
        //color: 'green',
      },
      '& .MuiInput-underline:after': {
        //borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        borderRadius:12,
        '& fieldset': {
          //borderColor: 'red',
        },
        '&:hover fieldset': {
          //borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          //borderColor: 'green',
        },
      },
    },
  })(TextField);

const InputSelectFormAvatar = props => {

    const {data, onChange, startAdornment, endAdornment} = props

    const onInnerChange = event => {
        const response = event.target.value;
        let temp = {...data};
        temp.value = response;
        temp.isValid = ruleValidation(temp.value, temp.rules, temp.value2);
        temp.isVisited = true;
        onChange(temp);
    } 

    const {config, value, isValid, isVisited, options} = data

    const isError = isVisited && !isValid
    let interConfig = {...config}
    if(!isError) interConfig.helperText = ''

    const _options = options ? options : []

    return(
        <div>
            <CssTextField  value={value} variant='outlined' color='secondary'
            error={isError} {...interConfig} select onChange={onInnerChange} 
            InputProps={
                {
                    startAdornment:startAdornment ? startAdornment : undefined,
                    endAdornment:endAdornment ? endAdornment : undefined,
                }}
            >
                {_options.map(item => {

                    return(
                        <MenuItem key={item.value.toString()} value={item.value}>
                            <UserAvatarName image={item.src} nopicture={item.nopicture} name={item.label} />    
                        </MenuItem>
                    )
                })}
            </CssTextField>
        </div>
    )
}

export default InputSelectFormAvatar